import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RevetementPlancher } from 'app/models/revetementPlancher.model';

@Injectable({
  providedIn: 'root'
})
export class RevetementPlancherService {

  private API_URL = environment.API_URL;
  private MODEL_URL = 'revetements-planchers';

  constructor(private http: HttpClient) { }

  getRevetementsPlanchers(): Observable<RevetementPlancher[]> {
    return this.http.get<RevetementPlancher[]>(this.API_URL + this.MODEL_URL);
  }

  store(revetementPlancher: RevetementPlancher): Observable<RevetementPlancher>{
    return this.http.post<RevetementPlancher>(this.API_URL + this.MODEL_URL, revetementPlancher).pipe(
      catchError(err => throwError(err))
    );
  }
}
